const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "add"
}, /*#__PURE__*/React.createElement("path", {
  d: "M357,204H204v153h-51V204H0v-51h153V0h51v153h153V204z"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", null);
var _ref4 = /*#__PURE__*/React.createElement("g", null);
var _ref5 = /*#__PURE__*/React.createElement("g", null);
var _ref6 = /*#__PURE__*/React.createElement("g", null);
var _ref7 = /*#__PURE__*/React.createElement("g", null);
var _ref8 = /*#__PURE__*/React.createElement("g", null);
var _ref9 = /*#__PURE__*/React.createElement("g", null);
var _ref0 = /*#__PURE__*/React.createElement("g", null);
var _ref1 = /*#__PURE__*/React.createElement("g", null);
var _ref10 = /*#__PURE__*/React.createElement("g", null);
var _ref11 = /*#__PURE__*/React.createElement("g", null);
var _ref12 = /*#__PURE__*/React.createElement("g", null);
var _ref13 = /*#__PURE__*/React.createElement("g", null);
var _ref14 = /*#__PURE__*/React.createElement("g", null);
var _ref15 = /*#__PURE__*/React.createElement("g", null);
function SvgAddButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "357px",
    height: "357px",
    viewBox: "0 0 357 357",
    style: {
      enableBackground: "new 0 0 357 357"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add-button.22a7687245ee3f06b575c67e1c13fdc5.svg";
export { ForwardRef as ReactComponent };